

<template>
  <component
    :is="component"
    ref="component"
    v-bind="componentParams"
    @focus="$emit('focus')"/>
</template>

<script>
import TooltipedTextLineCount from 'components/common/blocks/tooltiped text/TooltipedTextLineCount.vue'
import TooltipedSymbolCount from 'components/common/blocks/tooltiped text/TooltipedSymbolCount.vue'

/**
* Сворачивание текста (переключатель способа сворачивания)
* @category components
* @vue-prop {String} value - Текст (в случае url его описание)
* @vue-prop {Number} [maxLength=256] - Максимальная отображаемая длина
* @vue-prop {String} [tag='span'] - Тип эллемента
* @vue-prop {Boolean} [showTooltip=true] - Отобразить компонент разворота текста
* @vue-prop {Boolean} [textIsUrl=false] - Отобразить текст как ссылку
* @vue-prop {String} url - Текст
* @vue-prop {Object} [routeParams] - Параметры для router-link
* @vue-prop {Number} [lineCount=0] - Максимальное количество строк текста
* @vue-prop {Number} [lineHeight=1] - Высота строк текста
*/

export default {
  name: 'tooltipedText',
  props: {
    value: {
      type: String,
      default: '',
    },
    maxLength: {
      type: Number,
      default: 256,
    },
    tag: {
      type: String,
      default: 'span',
    },
    showTooltip: {
      type: Boolean,
      default: true,
    },
    textIsUrl: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
    },
    lineCount: {
      type: Number,
      default: 0,
    },
    lineHeight: {
      type: Number,
      default: 1,
    },
    innerStyle: {
      type: Object,
    },
    routeParams: {
      type: Object,
    },
  },
  computed: {
    component() {
      return this.lineCount === 0 ? 'TooltipedSymbolCount' : 'TooltipedTextLineCount'
    },
    componentParams() {
      const result = {
        value: this.value,
        tag: this.tag,
        showTooltip: this.showTooltip,
        textIsUrl: this.textIsUrl,
        url: this.url,
      }

      if (this.lineCount === 0) {
        result.maxLength = this.maxLength
      } else {
        result.lineCount = this.lineCount
        result.lineHeight = this.lineHeight
        result.innerStyle = this.innerStyle
        result.routeParams = this.routeParams
      }
      return result
    }
  },
  methods: {
    checkNeedShowTooltip() {
      if (this.$refs.component) {
        this.$refs.component.checkNeedShowTooltip()
      }
    },
  },
  components: {
    TooltipedSymbolCount,
    TooltipedTextLineCount,
  }
}
</script>
<style lang="scss">
.all-text-tooltip {
  max-width: 400px;
  max-height: 90% !important;
  overflow: auto;
}
</style>
